import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { OrderQuantitySelector } from "./OrderQuantitySelector";

interface Product {
  _id: string;
  name?: string;
  price: number;
}

interface CheckoutEmailStepProps {
  email: string;
  onEmailChange: (email: string) => void;
  products: Product[];
  quantities: Record<string, number>;
  onQuantityChange: (productId: string, quantity: number) => void;
  total: number;
}

export function CheckoutEmailStep({
  email,
  onEmailChange,
  products,
  quantities,
  onQuantityChange,
  total,
}: CheckoutEmailStepProps) {
  return (
    <div className="space-y-4 flex-1">
      <OrderQuantitySelector
        products={products}
        quantities={quantities}
        onQuantityChange={onQuantityChange}
        total={total}
      />
      <div className="space-y-2">
        <Label htmlFor="customer-email">Email *</Label>
        <Input
          id="customer-email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </div>
    </div>
  );
}
